// extracted by mini-css-extract-plugin
export default {"story":"Story_story__+Vz2t"};